import React from "react";
import ReactTooltip from "react-tooltip";
import { PageOverlayLoader } from "../../../../../shared/PageOverlayLoader/PageOverlayLoader.js";
import { ModalAppointmentDetails } from "../../widgets/ModalAppointmentDetails";
import { ModalRescheduleConfirm } from "../ModalRescheduleConfirm";
import { ModalPrint } from "../ModalPrint";
import { ModalRescheduleFee } from "../ModalRescheduleFee";
import { ModalRescheduleNotification } from "../ModalRescheduleNotification";

export function CalendarModals({
  state,
  appointmentLang,
  patientName,
  isLoading,
  onCloseAppointmentDetails,
  onCloseNotification,
  refetchAppointments,
  onFetchAppointmentSuccess,
  handleInputChange,
  handleEditorChange,
  sendNotification,
  dismissModal,
  chargeAndReschedule,
  print,
  closePrintModal,
  dismissRescheduleModal,
  rescheduleAppoint,
}) {
  return (
    <>
      {state.showAppointmentDetails && (
        <ModalAppointmentDetails
          id={Number(state.editAppointmentId)}
          onClose={onCloseAppointmentDetails}
          refetchAppointments={refetchAppointments}
          onFetchSuccess={onFetchAppointmentSuccess}
        />
      )}
      {state.showNotifyPop && (
        <ModalRescheduleNotification
          onClose={onCloseNotification}
          patientName={patientName}
          handleInputChange={handleInputChange}
          notificationType={state.notification_type}
          notificationBody={state.notification_body}
          handleEditorChange={handleEditorChange}
          sendNotification={sendNotification}
        />
      )}
      {state.showModal && (
        <ModalRescheduleFee
          fee={state.cancellation_fee}
          onClose={dismissModal}
          onReschedule={chargeAndReschedule}
        />
      )}
      {state.showPrintModal && (
        <ModalPrint onPrint={(type) => print(type)} onClose={closePrintModal} />
      )}
      {state.showRescheduleConfirmModal && (
        <ModalRescheduleConfirm
          onClose={dismissRescheduleModal}
          onConfirm={rescheduleAppoint}
        />
      )}
      {isLoading && (
        <PageOverlayLoader
          message={appointmentLang.appointment_processing_please_wait}
        />
      )}
      <ReactTooltip effect="float" multiline={true} place="left" />
    </>
  );
}
